// src/components/ContactForm.jsx
import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [captchaQuestion, setCaptchaQuestion] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [expectedAnswer, setExpectedAnswer] = useState(null);

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const a = Math.floor(Math.random() * 10);
    const b = Math.floor(Math.random() * 10);
    setCaptchaQuestion(`${a} + ${b}`);
    setExpectedAnswer(a + b);
    setCaptchaAnswer("");
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message || !captchaAnswer) {
      setStatus("Por favor, completá todos los campos.");
      return;
    }
    if (!validateEmail(form.email)) {
      setStatus("Ingresá un email válido.");
      return;
    }
    if (parseInt(captchaAnswer) !== expectedAnswer) {
      setStatus("Captcha incorrecto.");
      return;
    }

    setLoading(true);
    emailjs.send(SERVICE_ID, TEMPLATE_ID, form, PUBLIC_KEY)
      .then(() => {
        setSuccess(true);
        setStatus(null);
        setForm({ name: "", email: "", message: "" });
      })
      .catch(() => {
        setStatus("Ocurrió un error. Intentá de nuevo más tarde.");
      })
      .finally(() => {
        setLoading(false);
        generateCaptcha();
      });
  };

  return (
    <section className="section">
      <div className="container contact-wrapper">
        <h2 className="section-title">¿Querés escribirnos?</h2>
        <p className="contact-heading">Completá el formulario y nos pondremos en contacto con vos.</p>

        {success ? (
          <p style={{ fontSize: "1.2rem", color: "#f7981c" }}>
            ¡Gracias por contactarte con nosotros! Te responderemos pronto.
          </p>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Tu nombre"
              className="form-input styled-input"
              value={form.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Tu email"
              className="form-input styled-input"
              value={form.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Tu mensaje"
              className="form-textarea styled-input"
              value={form.message}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="captcha"
              placeholder={`¿Cuánto es ${captchaQuestion}?`}
              className="form-input styled-input"
              value={captchaAnswer}
              onChange={(e) => setCaptchaAnswer(e.target.value)}
              required
            />
            <button type="submit" className="form-button" disabled={loading}>
              {loading ? "Enviando..." : "Enviar"}
            </button>
          </form>
        )}

        {status && <p style={{ marginTop: "1rem", color: "#d32f2f" }}>{status}</p>}
      </div>
    </section>
  );
};

export default ContactForm;
